export abstract class ILocalStorageService {
  abstract getItem<T>(key: string): T | null;
  abstract setItem<T>(key: string, object: T): void;
  abstract clear(): void
  abstract removeItem(key: string): void;
}
